// Path: ./src/app/pages/CreateMerchantPage/styled.ts
import styled from "styled-components";
import { FlyerImageContainer } from "../CreateUploadFlyer/styled";
import { styled as MuiStyled } from "@mui/system";
import { TextareaAutosize } from "@mui/material";

export const LogoImageContainer = styled(FlyerImageContainer)`
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
`;

export const MerchantFormShell = styled.div`
  width: 100%;
  padding: 24px;
`;

export const MerchantSectionTitle = styled.h3`
  margin: 0 0 14px 0;
  font-size: 20px;
  font-weight: 700;
  color: #2f1d0f;
  letter-spacing: 0.2px;
`;

export const MerchantSectionHint = styled.p`
  margin: 0 0 16px 0;
  font-size: 13px;
  color: #8a6a53;
`;

export const FormGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(320px, 1fr) minmax(320px, 1fr);
  gap: 16px;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionCard = styled.div`
  border: 1px solid #ffd9bc;
  border-radius: 14px;
  background: #ffffff;
  padding: 14px 14px 8px 14px;
`;

export const SectionCardTitle = styled.h4`
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 700;
  color: #2f1d0f;
`;

export const FieldLabel = styled.div`
  min-width: 220px;
  max-width: 220px;
  font-size: 14px;
  font-weight: 700;
  color: #3f2a19;
  padding-top: 8px;

  @media (max-width: 980px) {
    min-width: 100%;
    max-width: 100%;
    padding-top: 0;
  }
`;

export const FieldControl = styled.div`
  width: 100%;
  max-width: 430px;

  @media (max-width: 980px) {
    max-width: 100%;
  }
`;

export const SeoGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(220px, 1fr);
  gap: 0 14px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;

  @media (max-width: 980px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const LogoPanels = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 8px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const LogoPanel = styled.div`
  border: 1px solid #ffd9bc;
  border-radius: 14px;
  background: #fff;
  padding: 18px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 16px;
`;

export const LogoPanelTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #2f1d0f;
`;

export const Textarea = MuiStyled(TextareaAutosize)(
  `
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.35;
  color: #2f1d0f;
  background: #fff;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #fecc9f;
  margin-bottom: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #f4ab70;
    box-shadow: 0 0 5px #fecc9f;
  }
  &:focus {
    border-color: #f29a57;
    box-shadow: 0 0 0 3px rgba(242, 154, 87, 0.25);
  }
  &:focus-visible {
    outline: 0;
  }
`,
);
